import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';

import PageLoader from '../loaders/pageLoader';
import { reactivateLoader } from '../loaders/signin/reactivateLoader';
import { registerActivateLoader } from '../loaders/signin/registerActivateLoader';

const AmexRegistrationForm = lazy(() => import('../../components/pages/userAccount/registerForm'));
const HsbcAccountPage = lazy(() => import('../../components/pages/userAccount/hsbc/accountPage'));
const AmexActivateForm = lazy(() => import('../../components/pages/userAccount/activateForm'));
const ErrorPage = lazy(() => import('../../components/pages/errorPage'));
const LoginForm = lazy(() => import('../../components/pages/userAccount/loginform'));
const ForgotPassword = lazy(() => import('../../components/pages/userAccount/forgotPassword'));
const ResetPassword = lazy(() => import('../../components/pages/userAccount/resetPassword'));
const MessagePage = lazy(() => import('../../components/pages/userAccount/common/messagePage'));

const signinPath = '/signin' as const;

const IS_AMEX_PROVIDER = globalThis.IS_PLAYWRIGHT_RUNNING
	? globalThis.PLAYWRIGHT_CARD_PROVIDER === 'AMEX'
	: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP;

// global flag to allow register page access via console only for sandbox
const ALLOW_REGISTER_PAGE_ACCESS = globalThis.config.IS_SANDBOX
	? localStorage.getItem('ALLOW_REGISTER_PAGE_ACCESS') === 'true' || globalThis.ALLOW_REGISTER_PAGE_ACCESS || false
	: false;

const isSandOrProdOrDemoEnv =
	globalThis.config.IS_PRODUCTION || globalThis.config.IS_SANDBOX || globalThis.config.IS_DEMO;

export const signinRoutes = {
	path: signinPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<Suspense fallback={<PageLoader />}>
					<LoginForm />
				</Suspense>
			),
		},
		{
			path: 'login',
			element: (
				<Suspense fallback={<PageLoader />}>
					<LoginForm />
				</Suspense>
			),
		},
		{
			// Redirect /signin/get-started to /signin/login
			// TODO : remove it after back-end removes this route
			path: 'get-started',
			element: <Navigate to={`${signinPath}/login`} replace />,
		},
		{
			path: 'password/forgot',
			element: (
				<Suspense fallback={<PageLoader />}>
					<ForgotPassword />
				</Suspense>
			),
		},
		{
			path: 'reactivate/:userId/:activationToken',
			element: (
				<Suspense fallback={<PageLoader />}>
					<ResetPassword />
				</Suspense>
			),
			loader: reactivateLoader,
		},
		{
			path: 'register',
			element: (
				<Suspense fallback={<PageLoader />}>
					{IS_AMEX_PROVIDER ? (
						<AmexRegistrationForm />
					) : isSandOrProdOrDemoEnv && !ALLOW_REGISTER_PAGE_ACCESS ? (
						<ErrorPage />
					) : (
						<HsbcAccountPage />
					)}
				</Suspense>
			),
		},
		{
			path: 'message',
			element: (
				<Suspense fallback={<PageLoader />}>
					<MessagePage />
				</Suspense>
			),
		},
		{
			path: 'activate/:userId/:activationToken',
			element: (
				<Suspense fallback={<PageLoader />}>{IS_AMEX_PROVIDER ? <AmexActivateForm /> : <HsbcAccountPage />}</Suspense>
			),
			loader: ctx => registerActivateLoader(ctx),
		},
		{
			path: 'register/activate/:userId/:activationToken',
			element: (
				<Suspense fallback={<PageLoader />}>{IS_AMEX_PROVIDER ? <AmexActivateForm /> : <HsbcAccountPage />}</Suspense>
			),
			loader: ctx => registerActivateLoader(ctx),
		},
	],
};
